import React, { useState, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import {
  Row, Col, Input,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import ExperienceCard from './ExperienceCard';

const ExperiencesTab = (props) => {
  const { isMobile, experiences, orgSlug } = props;

  const [searchQuery, setSearchQuery] = useState('');
  const [filteredExperiences, setFilteredExperiences] = useState([]);

  useEffect(() => {
    if (searchQuery) {
      if (searchQuery.length > 1 && experiences) {
        const experiencesFiltered = experiences.filter((e) => e.name?.toLowerCase().includes(searchQuery.toLowerCase())
        || e.description?.toLowerCase().includes(searchQuery.toLowerCase()));
        setFilteredExperiences(experiencesFiltered);
      }
    } else {
      setFilteredExperiences(experiences || []);
    }
  }, [searchQuery, experiences]);

  return (
    <div className="experiences-content">
      <span className="h2-w">Experiences</span>
      {!isMobile && (
        <>
          &nbsp;
          <strong>{experiences?.length || 0}</strong>
        </>
      )}
      {filteredExperiences?.length > 0 ? (
        <>
          <Input
            placeholder="Search Experiences"
            prefix={<SearchOutlined />}
            style={{
              width: '100%', borderRadius: 4, marginBottom: 20, marginTop: 20,
            }}
            size="large"
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <Row gutter={[20, 20]}>
            {filteredExperiences.map((experience) => (
              <Col span={isMobile ? 24 : 6} key={experience?.experience_id}>
                <ExperienceCard experience={experience} orgSlug={orgSlug} />
              </Col>
            ))}
          </Row>
        </>
      ) : (
        <p>No saved map experiences associated with this group could be found.</p>
      )}
    </div>
  );
};

export default memo(ExperiencesTab);

ExperiencesTab.propTypes = {
  isMobile: PropTypes.bool,
  experiences: PropTypes.array,
  orgSlug: PropTypes.string,
};

ExperiencesTab.defaultProps = {
  isMobile: false,
  experiences: [],
  orgSlug: null,
};
